export const USER_STORAGE = "jpBHjJNW1ONux3sTZeOdEkySJWUPOYfU";
export const CSRF_TOKEN_STORAGE = "csrfToken";

export { default as SINISTRES_STATUS } from "./sinistres_status.json";

export const POURCENTAGE_ASSURANCE_DUREE = {
  3: 26,
  6: 51,
};
export const TWO_FACTOR_AUTHENTICATION_TIMER = 180;
export const CONGO_PHONE_REGEX = /^(04|05|06)\d{7}$/;

export const TYPES_INTERMEDIAIRE = {
  AGENT_GENERAL: "AGENT_GENERAL",
  COURTIER: "COURTIER",
};

export const USERS_ROLE_ENUMS = {
  ROOT_ADMIN: "ROOT_ADMIN",
  POOL_USER: "POOL_USER",
  COMPANY_USER: "COMPANY_USER",
  COURTIER_USER: "COURTIER_USER",
  AGENT_GENERAL_USER: "AGENT_GENERAL_USER",
  COMPANY_AGENCY_USER: "COMPANY_AGENCY_USER",
  INTERMEDIAIRE_AGENCY_USER: "INTERMEDIAIRE_AGENCY_USER",
  EXTERNAL_ENTITY_USER: "EXTERNAL_ENTITY_USER",
};

export const USERS_BASE_ROUTES = {
  ROOT_ADMIN: "pool",
  POOL_USER: "pool",
  COMPANY_USER: "company",
  COURTIER_USER: "intermediaire",
  AGENT_GENERAL_USER: "intermediaire",
  COMPANY_AGENCY_USER: "agency",
  INTERMEDIAIRE_AGENCY_USER: "agency",
  EXTERNAL_ENTITY_USER: "pool",
};

export const USERS_ROLE_ENUMS_OPTIONS = [
  {
    key: "DEFAULT",
    text: "Choisir...",
    value: "",
  },
  {
    key: USERS_ROLE_ENUMS.ROOT_ADMIN,
    text: "Super Admnistrateur",
    value: USERS_ROLE_ENUMS.ROOT_ADMIN,
  },
  {
    key: USERS_ROLE_ENUMS.POOL_USER,
    text: "Pool",
    value: USERS_ROLE_ENUMS.POOL_USER,
  },
  {
    key: USERS_ROLE_ENUMS.COMPANY_USER,
    text: "Compagnie",
    value: USERS_ROLE_ENUMS.COMPANY_USER,
  },
  {
    key: USERS_ROLE_ENUMS.COURTIER_USER,
    text: "Courtier",
    value: USERS_ROLE_ENUMS.COURTIER_USER,
  },
  {
    key: USERS_ROLE_ENUMS.AGENT_GENERAL_USER,
    text: "Agent Général",
    value: USERS_ROLE_ENUMS.AGENT_GENERAL_USER,
  },
  {
    key: USERS_ROLE_ENUMS.INTERMEDIAIRE_AGENCY_USER,
    text: "Courtier/Agent Général (Agence)",
    value: USERS_ROLE_ENUMS.INTERMEDIAIRE_AGENCY_USER,
  },
  {
    key: USERS_ROLE_ENUMS.COMPANY_AGENCY_USER,
    text: "Bureau Direct (Agence)",
    value: USERS_ROLE_ENUMS.COMPANY_AGENCY_USER,
  },
  {
    key: USERS_ROLE_ENUMS.EXTERNAL_ENTITY_USER,
    text: "Entité Externe",
    value: USERS_ROLE_ENUMS.EXTERNAL_ENTITY_USER,
  },
];
export const LIENS_SOUSCRIPEUR_ASSURE = [
  {
    key: "DEFAULT",
    text: "Choisir...",
    value: "",
  },
  {
    key: "LUI_MEME",
    text: "Lui Même",
    value: "LUI_MEME",
  },
  {
    key: "ASCENDANT",
    text: "Ascendant",
    value: "ASCENDANT",
  },
  {
    key: "BEAUX_PARENT",
    text: "Beaux-Parent",
    value: "BEAUX_PARENT",
  },
  {
    key: "DESCENDANT",
    text: "Descendant",
    value: "DESCENDANT",
  },
  {
    key: "EMPLOYE",
    text: "Employé",
    value: "EMPLOYE",
  },
  {
    key: "MEMBRE",
    text: "Membre",
    value: "MEMBRE",
  },
  {
    key: "PARENT",
    text: "Parent",
    value: "PARENT",
  },
  {
    key: "AUTRE",
    text: "Autre",
    value: "AUTRE",
  },
];

export const TYPES_AVENANTS = {
  RESILIATION: "RESILIATION",
  SUSPENSION: "SUSPENSION",
  MODIFICATION_PRISE_EFFET: "MODIFICATION_PRISE_EFFET",
  CHANGEMENT_IMMATRICULATION: "CHANGEMENT_IMMATRICULATION",
  REMISE_EN_VIGUEUR: "REMISE_EN_VIGUEUR",
  INCORPORATION: "INCORPORATION",
  RETRAIT_GARANTIE: "RETRAIT_GARANTIE",
  DUPLICATA_ATTESTATION: "DUPLICATA_ATTESTATION",
  EXTENSION_GARANTIES: "EXTENSION_GARANTIES",
  CHANGEMENT_NOM: "CHANGEMENT_NOM",
  AFFAIRE_NOUVELLE: "AFFAIRE_NOUVELLE",
  CHANGEMENT_VEHICULE: "CHANGEMENT_VEHICULE",
  RETRAIT_VEHICULE: "RETRAIT_VEHICULE",
  RENOUVELLEMENT: "RENOUVELLEMENT",
  MODIFICATION_RISQUES: "MODIFICATION_RISQUES",
  ANNULATION: "ANNULATION",
};

export const AVENANTS_NECESSITANT_EDITION_ATTESTATION = [
  TYPES_AVENANTS.DUPLICATA_ATTESTATION,
  TYPES_AVENANTS.REMISE_EN_VIGUEUR,
  TYPES_AVENANTS.CHANGEMENT_VEHICULE,
  TYPES_AVENANTS.CHANGEMENT_NOM,
  TYPES_AVENANTS.CHANGEMENT_IMMATRICULATION,
  TYPES_AVENANTS.REMISE_EN_VIGUEUR,
  TYPES_AVENANTS.DUPLICATA_ATTESTATION,
  TYPES_AVENANTS.INCORPORATION,
  TYPES_AVENANTS.RENOUVELLEMENT,
  TYPES_AVENANTS.MODIFICATION_PRISE_EFFET,
  TYPES_AVENANTS.MODIFICATION_RISQUES,
];
